if (typeof angular !== 'undefined') {

	var dataLayer = dataLayer || [];

	var ulekareApp = angular.module('ulekareApp', ['ngFileUpload', '720kb.tooltips']);
	ulekareApp.run(function($http){
		$http.defaults.headers.post = $http.defaults.headers.post || {};
		$http.defaults.headers.post['X-Api-Key'] = ulekareBackendVars.apiKey;
		$http.defaults.headers.get = $http.defaults.headers.get || {};
		$http.defaults.headers.get['X-Api-Key'] = ulekareBackendVars.apiKey;
		$http.defaults.headers.put = $http.defaults.headers.put || {};
		$http.defaults.headers.put['X-Api-Key'] = ulekareBackendVars.apiKey;
		$http.defaults.headers.delete = $http.defaults.headers.delete || {};
		$http.defaults.headers.delete['X-Api-Key'] = ulekareBackendVars.apiKey;
	});

	ulekareApp.directive('displayInvalid', function($parse, $filter) {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function(scope, elm, attrs, model) {
				var displayed = false;
				scope.$watch(attrs.ngModel, function(newValue, oldValue, scope) {
					// only set once... on initial load
					if(displayed == false && newValue != undefined){
						displayed = true;
						elm.val(model.$modelValue);
					}
				});
			}
		}
	});


	ulekareApp.filter('inArray', function() {
		return function(item, list) {
			return list.indexOf(item) !== -1;
		}
	});


	ulekareApp.filter('notInArray', function() {
		return function(item, list) {
			return list.indexOf(item) === -1;
		}
	});

	ulekareApp.filter('split', function() {
		return function(input, splitChar, splitIndex) {
			return input.split(splitChar)[splitIndex];
		}
	});
} else {
	// virtual function to mock angular
	var ulekareApp = {
		'controller': function() {},
		'factory': function() {},
		'filter': function() {},
		'directive': function() {},
	};
}

UL.onJqueryLoad(function() {
	if ($('.m-walkthrough').length > 0) {
		var Walkthrough = {
			DECREASE: 'decrease',
			INCREASE: 'increase',
			SELECTORS: {
				CLOSE: [
					'.m-walkthrough .m-walkthrough__close',
					'.m-walkthrough .m-walkthrough__actions .close',
					'.m-walkthrough__overlayer',
				].join(','),
				PREV_AND_NEXT: [
					'.m-walkthrough .m-walkthrough__btn__prev',
					'.m-walkthrough .m-walkthrough__btn__next',
					'.m-walkthrough .next-step',
				].join(','),
				DOT: '.m-walkthrough .m-walkthrough__dot',
			},
			KEY_EVENTS: {
				ESC: 27,
				LEFT_ARROW: 37,
				RIGHT_ARROW: 39
			},
			step: 1,
			transiting: false,
			init: function() {
				if (this.step !== 1) {
					this.reset();
				}
				this.logWalkthroughStep(this.step);
				$(Walkthrough.SELECTORS.CLOSE).on('click', this.close.bind(this));
				$(Walkthrough.SELECTORS.PREV_AND_NEXT).on('click', this.changeStepByBtn.bind(this));
				$(Walkthrough.SELECTORS.DOT).on('click', this.changeStepByDot.bind(this));
				$(document).on('keyup', this.changeStepByArrow.bind(this));

				Walkthrough.disableScroll();
			},
			disableScroll: function() {
				if ($('.m-walkthrough__step[data-step=' + Walkthrough.step + ']').innerHeight() < $('.m-walkthrough__step[data-step=' + Walkthrough.step + ']').prop('scrollHeight')) {
					$('.m-walkthrough__step[data-step=' + Walkthrough.step + ']').css('overflow-x', 'hidden');
					$('.m-walkthrough__step[data-step=' + Walkthrough.step + ']').css('overflow-y', 'scroll');
					$('body').css('overflow', 'hidden');
				}
			},
			show: function(e) {
				e.preventDefault();

				$('.m-walkthrough').fadeIn();

				Walkthrough.init();

			},
			close: function(e) {
				e.preventDefault();

				if ($(e.currentTarget).hasClass('close')) {
					this.ask();
				}

				$('.m-walkthrough').fadeOut();
				$('.m-walkthrough__step').css('overflow-x', 'none');
				$('.m-walkthrough__step').css('overflow-y', 'none');
				$('body').css('overflow', 'auto');

				$(Walkthrough.SELECTORS.CLOSE).off('click');
				$(Walkthrough.SELECTORS.PREV_AND_NEXT).off('click');
				$(document).off('keyup');

				var d = new Date();
				d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
				var expires = "expires=" + d.toUTCString();
				if (ulekareBackendVars.isPartner) {
					document.cookie = "partner_consultation_walkthrough_seen=true;" + expires + ";path=/";
				} else if (ulekareBackendVars.isOrder) {
					document.cookie = "order_walkthrough_seen=true;" + expires + ";path=/";
				} else {
					document.cookie = "consultation_walkthrough_seen=true;" + expires + ";path=/";
				}
			},
			ask: function() {
				$.scrollTo('.m-layout-form', 1500, {offset: -74});
				$('textarea').focus();
			},
			changeStepByBtn: function(e) {
				e.preventDefault();
				var action = $(e.currentTarget).hasClass('m-walkthrough__btn__prev') ? Walkthrough.DECREASE : Walkthrough.INCREASE;
				var futureStep = this.resolveStep(action);
				this.transite(futureStep);
			},
			changeStepByArrow: function(e) {
				if (e.keyCode === Walkthrough.KEY_EVENTS.LEFT_ARROW || e.keyCode === Walkthrough.KEY_EVENTS.RIGHT_ARROW) {
					var futureStep = this.resolveStep((e.keyCode === Walkthrough.KEY_EVENTS.LEFT_ARROW) ? Walkthrough.DECREASE : Walkthrough.INCREASE);
					this.transite(futureStep);
				} else if (e.keyCode === Walkthrough.KEY_EVENTS.ESC) {
					this.close(e);
				}
			},
			changeStepByDot: function(e) {
				var futureStep = parseInt($(e.currentTarget).data('step'));
				this.transite(futureStep);
			},
			resolveStep: function(action) {
				var futureStep = this.step;
				var numOfSteps = $('.m-walkthrough .m-walkthrough__step').length;

				if (action === Walkthrough.INCREASE && this.step < numOfSteps) {
					futureStep = this.step + 1;
				} else if (action === Walkthrough.DECREASE && this.step > 1) {
					futureStep = this.step - 1;
				}

				return futureStep;
			},
			transite: function(futureStep) {
				if (this.transiting || this.step === futureStep) {
					return false;
				}

				var numOfSteps = $('.m-walkthrough .m-walkthrough__step').length;

				this.showStep(futureStep);

				var prevBtn = $('.m-walkthrough__btn__prev');
				var nextBtn = $('.m-walkthrough__btn__next');

				if (futureStep === 1) {
					prevBtn.fadeOut();
				} else {
					prevBtn.fadeIn();
				}

				if (futureStep === numOfSteps) {
					nextBtn.fadeOut();
				} else {
					nextBtn.fadeIn();
				}

				this.step = futureStep;

				if ($('.m-walkthrough__step[data-step=' + this.step + ']').innerHeight() < $('.m-walkthrough__step[data-step=' + this.step + ']').prop('scrollHeight')) {
					$('.m-walkthrough__step[data-step=' + this.step + ']').css('overflow-x', 'hidden');
					$('.m-walkthrough__step[data-step=' + this.step + ']').css('overflow-y', 'scroll');
				}
			},
			showStep: function(futureStep) {
				this.logWalkthroughStep(futureStep);
				this.transiting = true;

				if (this.step < futureStep) {
					for (var i = this.step; i < futureStep; i++) {
						$('.m-walkthrough .m-walkthrough__step[data-step=' + i + ']').removeClass('next').addClass('prev');
					}
				} else {
					for (var i = this.step; i > futureStep; i--) {
						$('.m-walkthrough .m-walkthrough__step[data-step=' + i + ']').removeClass('prev').addClass('next');
					}
				}

				$('.m-walkthrough .m-walkthrough__step[data-step=' + futureStep + ']').removeClass('prev').removeClass('next');
				$('.m-walkthrough .m-walkthrough__dot[data-step=' + this.step + ']').removeClass('active');
				$('.m-walkthrough .m-walkthrough__dot[data-step=' + futureStep + ']').addClass('active');

				var that = this;
				setTimeout(function() {
					that.transiting = false;
				}, 1000);
			},
			reset: function() {
				this.step = 1;

				$('.m-walkthrough .m-walkthrough__step:not([data-step=1])').removeClass('prev').addClass('next');
				$('.m-walkthrough .m-walkthrough__step[data-step=1]').removeClass('next, prev');
				$('.m-walkthrough .m-walkthrough__dot:not([data-step=1])').removeClass('active');
				$('.m-walkthrough .m-walkthrough__dot[data-step=1]').addClass('active');
				$('.m-walkthrough__btn__prev').stop(true).hide();
				$('.m-walkthrough__btn__next').stop(true).show();
			},
			pushDataLayer: function(content) {
				dataLayer.push(content);
			},
			logWalkthroughStep: function(stepNumber) {
				this.pushDataLayer({
					'event': 'virtualPageView',
					'formStep': '/hrb-pruvodce-krok-' + stepNumber
				});
			}
		};

		if ($('.m-walkthrough').hasClass('active')) {
			Walkthrough.init();
		}

		window.Walkthrough = Walkthrough;

		$('.show-walkthrough').on('click', Walkthrough.show);
		$('.ask-question').on('click', Walkthrough.ask);
	}

	var $closableModalNotice = $('.m-modal-notice.closable');

	var hideClosableModalNotice = function(e) {
		e.preventDefault();
		$closableModalNotice.fadeOut();
	};

	$('.m-modal-notice .m-btn.close').on('click', hideClosableModalNotice);
});
